import { IconProps } from './types';

export const DuplicateIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 19.305 22.353'>
    <path
      // eslint-disable-next-line max-len
      d='M17.225,1.5H5.032A2.038,2.038,0,0,0,3,3.532V17.757H5.032V3.532H17.225Zm3.048,4.064H9.1A2.038,2.038,0,0,0,7.064,7.6V21.821A2.038,2.038,0,0,0,9.1,23.853H20.273a2.038,2.038,0,0,0,2.032-2.032V7.6A2.038,2.038,0,0,0,20.273,5.564Zm0,16.257H9.1V7.6H20.273Z'
      transform='translate(-3 -1.5)'
      fill='#fff'
      {...props}
    />
  </svg>
);
